/* eslint-disable no-plusplus */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table } from 'antd';
import { Editor } from 'react-draft-wysiwyg';

import QUERY from '../../graphql/queries/getCustomerFactsheetQuery.graphql';

const { Column, ColumnGroup } = Table;

const FactsheetOverview = (props) => {
  const { loading, customerFactsheet } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const constitutionId = customerFactsheet.constitution.id;
  let counter = 1;
  let totalPbaAmount = 0;
  customerFactsheet.present_banking_arrangements.forEach((pba) => {
    totalPbaAmount += pba.sanction_bg_lc + pba.sanction_tl + pba.sanction_cc;
  });
  return (
    <div id="factsheet-overview">
      <h5>{counter++}. Name of the Customer</h5>
      <div><p>{customerFactsheet.name}</p></div>
      <h5>{counter++}. Constitution</h5>
      <div><p>{customerFactsheet.constitution.name}</p></div>
      <h5>{counter++}. Sector</h5>
      <div><p>{customerFactsheet.sector.name}</p></div>
      <h5>{counter++}. Sub-Sector</h5>
      <div><p>{customerFactsheet.sub_sector}</p></div>
      <h5>{counter++}. Line of Activity</h5>
      <div><p>{customerFactsheet.line_of_activity}</p></div>
      <h5>{counter++}. Date of {(constitutionId === 6) ? 'Birth' : 'Formation'}</h5>
      <div><p>{customerFactsheet.details.formation_date}</p></div>
      <h5>{counter++}. PAN</h5>
      <div><p>{customerFactsheet.details.pan_no}</p></div>
      <h5>{counter++}. No. of Directors/Partners/Trustees</h5>
      <div><p>{customerFactsheet.management_persons.length}</p></div>
      <h5>{counter++}. Management Team</h5>
      <div>
        <Table dataSource={customerFactsheet.management_persons} size="small" bordered rowKey="id" pagination={false}>
          <Column
            title="Name"
            key="name"
            render={(text, record) => (<span>{`${record.first_name} ${record.middle_name} ${record.last_name}`}</span>)}
          />
          <Column
            title="Father's Name"
            key="father_name"
            render={(text, record) => (<span>{`${record.father_first_name} ${record.father_middle_name} ${record.father_last_name}`}</span>)}
          />
          <Column
            title="Details"
            key="details"
            render={(text, record) => (
              <div>
                <p><strong>DOB: </strong>{record.dob}</p>
                <p><strong>PAN: </strong>{record.pan_no}</p>
                <p><strong>Aadhaar: </strong>{record.aadhaar_no}</p>
              </div>
            )}
          />
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                {record.street_address}
                <br />
                {record.city}, {record.state} - {record.pincode}
              </span>
            )}
          />
          <Column
            title="Networth"
            dataIndex="networth"
            key="networth"
            render={(text, record) => (record.networth.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))}
          />
        </Table>
      </div>
      <h5>{counter++}. Ownership</h5>
      <div>
        <Table dataSource={customerFactsheet.management_persons.filter((person) => (person.is_shareholder))} size="small" bordered rowKey="id" pagination={false}>
          <Column
            title="Name"
            key="name"
            render={(text, record) => (<span>{`${record.first_name} ${record.middle_name} ${record.last_name}`}</span>)}
          />
          <Column
            title="% Share"
            dataIndex="percent_share"
            key="percent_share"
            render={(text) => (`${text} %`)}
          />
          <Column
            title="DIN"
            dataIndex="din"
            key="din"
          />
          <Column
            title="DPIN"
            dataIndex="dpin"
            key="dpin"
          />
        </Table>
      </div>
      <h5>{counter++}. Addresses</h5>
      <div>
        <Table dataSource={customerFactsheet.addresses} size="small" bordered rowKey="id" pagination={false}>
          <Column
            title="Type"
            key="type"
            dataIndex="type.name"
          />
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                {record.address}
                <br />
                {record.city}, {record.state} - {record.pincode}
              </span>
            )}
          />
        </Table>
      </div>

      <h5>{counter++}. Present Banking Arrangement - Overview</h5>
      <div>
        <Table dataSource={customerFactsheet.present_banking_arrangements} size="small" bordered rowKey="id" pagination={false}>
          <Column
            title="Name of Bank"
            dataIndex="bank_name"
            key="bank_name"
          />
          <ColumnGroup title="Sanction Amount">
            <Column
              title="BG/LC"
              dataIndex="sanction_bg_lc"
              key="sanction_bg_lc"
            />
            <Column
              title="TL"
              dataIndex="sanction_tl"
              key="sanction_tl"
            />
            <Column
              title="CC"
              dataIndex="sanction_cc"
              key="sanction_cc"
            />
            <Column
              title="Total"
              key="sanction_total"
              render={(text, record) => (record.sanction_bg_lc + record.sanction_tl + record.sanction_cc)}
            />
          </ColumnGroup>
          <Column
            title="Share"
            key="share"
            render={(text, record) => ((((record.sanction_bg_lc + record.sanction_tl + record.sanction_cc) / totalPbaAmount) * 100).toFixed(2))}
          />
          <ColumnGroup title="Outstanding Amount">
            <Column
              title="Date"
              key="oa_date"
              render={(text, record) => (record.outstanding_amounts[0].date)}
            />
            <Column
              title="BG/LC"
              key="oa_bg_lc"
              render={(text, record) => (record.outstanding_amounts[0].bg_lc)}
            />
            <Column
              title="TL"
              key="oa_tl"
              render={(text, record) => (record.outstanding_amounts[0].tl)}
            />
            <Column
              title="CC"
              key="oa_cc"
              render={(text, record) => (record.outstanding_amounts[0].cc)}
            />
            <Column
              title="Total"
              key="oa_total"
              render={(text, record) => (record.outstanding_amounts[0].bg_lc + record.outstanding_amounts[0].tl + record.outstanding_amounts[0].cc)}
            />
          </ColumnGroup>
        </Table>
      </div>

      <h5>{counter++}. Present Banking Arrangement - Detailed</h5>
      <div>
        {
          customerFactsheet.present_banking_arrangements.map((pba, index) => (
            <div key={pba.id}>
              <p style={{marginTop: 10, fontSize: '1.1rem'}}><strong>{index+1}. {pba.bank_name}</strong></p>
              <div style={{paddingLeft: 15}}>
                <Table dataSource={[pba]} size="small" bordered rowKey="id" pagination={false}>
                  <ColumnGroup title="Sanction Amount">
                    <Column
                      title="BG/LC"
                      dataIndex="sanction_bg_lc"
                      key="sanction_bg_lc"
                    />
                    <Column
                      title="TL"
                      dataIndex="sanction_tl"
                      key="sanction_tl"
                    />
                    <Column
                      title="CC"
                      dataIndex="sanction_cc"
                      key="sanction_cc"
                    />
                    <Column
                      title="Total"
                      key="sanction_total"
                      render={(text, record) => (record.sanction_bg_lc + record.sanction_tl + record.sanction_cc)}
                    />
                  </ColumnGroup>
                  <ColumnGroup title="Outstanding Amount">
                    <Column
                      title="Date"
                      key="oa_date"
                      render={(text, record) => (record.outstanding_amounts[0].date)}
                    />
                    <Column
                      title="BG/LC"
                      key="oa_bg_lc"
                      render={(text, record) => (record.outstanding_amounts[0].bg_lc)}
                    />
                    <Column
                      title="TL"
                      key="oa_tl"
                      render={(text, record) => (record.outstanding_amounts[0].tl)}
                    />
                    <Column
                      title="CC"
                      key="oa_cc"
                      render={(text, record) => (record.outstanding_amounts[0].cc)}
                    />
                    <Column
                      title="Total"
                      key="oa_total"
                      render={(text, record) => (record.outstanding_amounts[0].bg_lc + record.outstanding_amounts[0].tl + record.outstanding_amounts[0].cc)}
                    />
                  </ColumnGroup>
                </Table>
                <p><strong>Sanction ROI: </strong>{pba.roi}</p>
                <p><strong>Asset Classification: </strong>{pba.asset_classification}</p>
                <p><strong>Repayment Schedule:</strong></p>
                <Table dataSource={pba.repayment_schedule} rowKey="id" pagination={false} size="small">
                  <Column
                    width={100}
                    title="Date"
                    key="date"
                    render={(text, record) => (`${record.month}-${record.year}`)}
                  />
                  <Column
                    title="Amount"
                    key="amount"
                    render={(text, record) => (record.amount)}
                  />
                </Table>
                <p><strong>Securities:</strong></p>
                <Table dataSource={pba.securities} rowKey="id" pagination={false}>
                  <Column
                    title="Address"
                    key="address"
                    render={(text, record) => (
                      <span>
                        {record.address}
                        <br />
                        {record.city}, {record.state} - {record.pincode}
                      </span>
                    )}
                  />
                  <Column
                    title="Property type"
                    dataIndex="property_type"
                    key="property_type"
                  />
                  <Column
                    title="Owned By"
                    dataIndex="owned_by"
                    key="owned_by"
                  />
                  <Column
                    title="Plot Area"
                    dataIndex="plot_area"
                    key="plot_area"
                  />
                  <Column
                    title="Construction Area"
                    dataIndex="construction_area"
                    key="construction_area"
                  />
                  <Column
                    title="Valuation"
                    dataIndex="valuation"
                    key="valuation"
                  />
                </Table>
              </div>
            </div>
          ))
        }
      </div>

      <h5>{counter++}. Proposed Loans</h5>
      <div>
        <Table dataSource={customerFactsheet.details.proposed_loans} rowKey="product_type" size="small" pagination={false}>
          <Column
            title="Type of Product"
            key="product_type"
            dataIndex="product_type"
          />
          <Column
            title="End Use"
            key="end_use"
            dataIndex="end_use"
          />
          <Column
            title="Security offered in %"
            key="percent_security"
            dataIndex="percent_security"
          />
        </Table>
      </div>

      <h5>{counter++}. Background of the Company</h5>
      <div>
        <Editor
          readOnly
          toolbarStyle={{ display: 'none' }}
          initialContentState={JSON.parse(customerFactsheet.details.company_background)}
        />
      </div>

      <h5>{counter++}. Background of the Promoters</h5>
      <div>
        <Editor
          readOnly
          toolbarStyle={{ display: 'none' }}
          initialContentState={JSON.parse(customerFactsheet.details.promoters_background)}
        />
      </div>

      <h5>{counter++}. Background of Current Project</h5>
      <div>
        <Editor
          readOnly
          toolbarStyle={{ display: 'none' }}
          initialContentState={JSON.parse(customerFactsheet.details.project_background)}
        />
      </div>

      <h5>{counter++}. Securities</h5>
      <div>
        <h6>Primary</h6>
        <Table dataSource={customerFactsheet.securities.filter((security) => (security.type === 'Primary'))} rowKey="id" pagination={false}>
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                        {record.address}
                <br />
                {record.city}, {record.state} - {record.pincode}
                      </span>
            )}
          />
          <Column
            title="Property type"
            dataIndex="property_type"
            key="property_type"
          />
          <Column
            title="Owned By"
            dataIndex="owned_by"
            key="owned_by"
          />
          <Column
            title="Plot Area"
            dataIndex="plot_area"
            key="plot_area"
          />
          <Column
            title="Construction Area"
            dataIndex="construction_area"
            key="construction_area"
          />
          <Column
            title="Valuation"
            dataIndex="valuation"
            key="valuation"
          />
        </Table>
        <h6>Collateral</h6>
        <Table dataSource={customerFactsheet.securities.filter((security) => (security.type === 'Collateral'))} rowKey="id" pagination={false}>
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                        {record.address}
                <br />
                {record.city}, {record.state} - {record.pincode}
                      </span>
            )}
          />
          <Column
            title="Property type"
            dataIndex="property_type"
            key="property_type"
          />
          <Column
            title="Owned By"
            dataIndex="owned_by"
            key="owned_by"
          />
          <Column
            title="Plot Area"
            dataIndex="plot_area"
            key="plot_area"
          />
          <Column
            title="Construction Area"
            dataIndex="construction_area"
            key="construction_area"
          />
          <Column
            title="Valuation"
            dataIndex="valuation"
            key="valuation"
          />
        </Table>
        <h6>Guarantee</h6>
        <Table dataSource={customerFactsheet.management_persons.filter((person) => (person.is_guarantor))} rowKey="id" pagination={false}>
          <Column
            title="Name"
            key="name"
            render={(text, record) => (<span>{`${record.first_name} ${record.middle_name} ${record.last_name}`}</span>)}
          />
          <Column
            title="Networth"
            dataIndex="networth"
            key="networth"
            render={(text, record) => (record.networth.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))}
          />
        </Table>
      </div>

      <h5>{counter++}. Ecosystem Brief</h5>
      <div>
        <Editor
          readOnly
          toolbarStyle={{ display: 'none' }}
          initialContentState={JSON.parse(customerFactsheet.details.ecosystem_brief)}
        />
      </div>

      <h5>{counter++}. Other Observations & Comments</h5>
      <div>
        <Editor
          readOnly
          toolbarStyle={{ display: 'none' }}
          initialContentState={JSON.parse(customerFactsheet.details.remarks)}
        />
      </div>
    </div>
  );
};

FactsheetOverview.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerFactsheet: PropTypes.object,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(FactsheetOverview);



// WEBPACK FOOTER //
// ./src/pages/factsheet/FactsheetOverview.jsx